/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Copy_CodeInputs */

const en_two_fa_copy_code = /** @type {(inputs: Two_Fa_Copy_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy code`)
};

const nl_two_fa_copy_code = /** @type {(inputs: Two_Fa_Copy_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code kopiëren`)
};

/**
* | output |
* | --- |
* | "Copy code" |
*
* @param {Two_Fa_Copy_CodeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_copy_code = /** @type {((inputs?: Two_Fa_Copy_CodeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Copy_CodeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_copy_code(inputs)
	return en_two_fa_copy_code(inputs)
});